/**
=========================================================
* Argon Dashboard 2 PRO MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-mui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// Argon Dashboard 2 PRO MUI components
import ArgonBox from "components/ArgonBox";

// Argon Dashboard 2 PRO MUI example components
import ArgonTypography from "components/ArgonTypography";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import BusinessNavbar from "examples/Navbars/DashboardNavbar/businessNavbar";

function ComingSoon() {
  return (
    <DashboardLayout>
      <BusinessNavbar />
      <ArgonBox py={3} pb="70px">
        {" "}
        {/* Added bottom padding for footer */}
        <ArgonTypography variant="h4" fontWeight="bold" mb={3}>
          {" "}
          Questa funzione è in fase di sviluppo... Rilasciata a brevissimo!{" "}
        </ArgonTypography>
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ComingSoon;
